import { ProgressBar } from 'primereact/progressbar';
import React from 'react';
import styled from 'styled-components';

const StyledProgressBar = styled(ProgressBar)<StyledProgressBarProps>`
  border-radius: ${(props) =>
    props.slim ? 'var(--grand-border-radius)' : 'var(--small-border-radius)'};
  background-color: ${(props) =>
    props.slim ? 'var(--gray-dark)' : 'var(--gray-pale)'};
  height: ${(props) => (props.slim ? '6px' : '28px')};

  .p-progressbar-value {
    justify-content: start;
    border-radius: ${(props) =>
      props.slim ? 'var(--grand-border-radius)' : 'var(--small-border-radius)'};
    background: ${(props) =>
      props.isPurple ? 'var(--purple-middle)' : 'var(--red-main)'};
    font-size: var(--small-font-size);
    min-width: ${(props) => (props.slim ? '0' : '45px')};
  }

  .p-progressbar-label {
    padding: 0 var(--small-padding);
    line-height: 1;
  }
`;

const SyledSpan = styled('span')`
  position: absolute;
  color: var(--white-main);
  padding: 0 var(--small-padding);
  font-size: var(--small-font-size);
  top: 50%;
  transform: translate(0, -50%);
`;

type StyledProgressBarProps = {
  isPurple?: boolean;
  slim?: boolean;
};

type AppProgressBarProps = {
  value: number;
  isPurple?: boolean;
  slim?: boolean;
};

const AppProgressBar: React.FC<
  AppProgressBarProps & React.HTMLAttributes<any>
> = ({ value, isPurple, slim, ...rest }) => (
  <div className="relative w-full">
    <StyledProgressBar
      value={value}
      isPurple={isPurple}
      slim={slim}
      showValue={!slim}
      {...rest}
    />
    {!slim && value === 0 && <SyledSpan>0%</SyledSpan>}
  </div>
);

export default AppProgressBar;
